import { Platform, useWindowDimensions } from 'react-native';
import { useContext } from 'react';
import ResponsiveViewportContext from '@/context/ResponsiveViewportContext';

export const XS_BREAKPOINT = 767;
export const SM_BREAKPOINT = 992;
export const MD_BREAKPOINT = 1160;
export const XL_BREAKPOINT = 1500;

export default function useResponsiveness() {
  const window = useWindowDimensions();
  const viewport = useContext(ResponsiveViewportContext);
  const { width: windowWidth, height: windowHeight } =
    Platform.OS === 'macos' && viewport ? viewport : window;

  const isXS = windowWidth <= XS_BREAKPOINT;
  const isSM = windowWidth <= SM_BREAKPOINT;
  const isMD = windowWidth <= MD_BREAKPOINT;

  return {
    isXS,
    isSM,
    isMD,
    /** Wider than the MD breakpoint (desktop / wide tablet). */
    isLG: windowWidth > MD_BREAKPOINT,
    isXL: windowWidth >= XL_BREAKPOINT,

    windowWidth,
    windowHeight,

    /**
     * Native: always true (system scrollbars).
     * Web: true only above XS — RN Web hides scrollbars when false (undraggable thumb);
     * narrow web stays false for touch-first layouts.
     */
    showsScrollIndicator: Platform.OS !== 'web' || !isXS,
  };
}
